/**
 * @file FVNO提供形態情報を管理するステート
 *
 * FVNO（仮想固定線事業者）の提供形態（既存スキーム/ORIXスキーム）と
 * 10Gsプランフラグを保持する。提供形態により利用可能なオプションや
 * 表示内容が変わるため、画面制御の判定に使用される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import { FvnoProvideTypeResponse } from '@/types/api/mypage/fvnoProvideType';
import persistAtom from './recoilPersist';

/**
 * FVNO提供形態情報を保持するRecoil atom。
 * fvno_type: '1'=既存スキーム, '2'=ORIXスキーム。
 * teng_s_plan_flg: '0'=10Gsプランでない, '1'=10Gsプラン。
 */
export const fvnoProvideTypeState = atom<FvnoProvideTypeResponse>({
  key: 'fvnoProvideState',
  default: {
    fvno_type: '',
    teng_s_plan_flg: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default fvnoProvideTypeState;
